import React, { HTMLAttributes } from "react";
import Footer from "../../../components/molecules/footer";
import Header from "../../../components/molecules/header";
import "./index.css";

interface ITERMS {}

type TTERMSProps = ITERMS & HTMLAttributes<HTMLDivElement>;

const TERMS: React.FC<TTERMSProps> = (props) => {
  const { ...otherProps } = props;

  return (
    <div
      className="flex flex-1 flex-col min-h-[100dvh] h-full text-white"
      {...otherProps}
    >
      <Header />
      <div className="h-full min-h-[500px] overflow-auto flex flex-col text-left bg-bgDark p-10 text-sm">
        <h1 className="text-center mb-5">TERMS</h1>

        <span>
          Please carefully read these terms and conditions (“Terms and
          Conditions”), the Services Personal Information Collection Statement
          (“PICS”; see clause 7 of these Terms and Conditions) and my Privacy
          Policy (“Privacy Policy”) for the Asgard EV mobile application
          (“Asgard EV App”) and Asgard EV Charging Payment Services (“Services”,
          as defined below) before using the Asgard EV App and Services. The
          Asgard EV App and Services are provided by Asgard Group Limited
          (referred to as I, me, my, mine and myself) at EV Charging Facilities
          (as defined below). By using the Services, you are deemed to have
          read, understood and agreed to be bound by these Terms and Conditions,
          the PICS and the Privacy Policy. If you do not agree to be bound by
          these Terms and Conditions, you will not be able to use the Asgard EV
          App or Services.
        </span>
        <br />
        <ol className="terms-list">
          {/* term 1 */}
          <li>
            <strong>Definitions and interpretations</strong>
            <div className="m-4 text-sm">
              Unless otherwise deined, these terms should have the following
              meanings:
            </div>
            <ol>
              <li>
                "Application” means any and all versions (including, if any,
                updates, upgrades, beta versions or any combination of them) of
                the software or program used to provide the Services in any
                form, format, media and medium, and any and all websites,
                micro-sites, software, computer programs, mobile apps and
                systems and, for such sites, programs and systems, any other
                combination of online, digital, electronic and interactive
                platforms (including front-end and back-end systems), and any
                Derivative Works created from or of them, whether conceived or
                existing before or after the date of these Terms and Conditions.
              </li>
              <li>
                “Derivative Works” means any work created from, based on or
                derived from the existing works (or any of them) concerned,
                including modifications, improvements, compilations, annotations
                and translations.
              </li>
              <li>
                “EV Charging Facilities” means the locations (such as carparks)
                listed by me from time to time that are using the Asgard EV app
                and Services to collect payment for their EV charging services.
              </li>
              <li>
                “Asgard EV Charging Payment Services” or “Services” means a
                service feature offered through the Asgard EV App (with or
                without a payment kiosk) for reporting the EV charging fees due
                and collecting payment of those EV charging fees after a User’s
                EV is charged at an EV Charging Facility.
              </li>
              <li>
                “Required Information” means the type of information you are
                required to provide me during registration for the Services on
                the Asgard EV App as further specified in clause 7 (the PICS).
                Required Information includes your name (as used on your credit
                card, car registration or both), email address, mobile phone
                number, registered license plate number (also referred to as a
                “vehicle registration mark”), Asgard EV App identification
                number (as applicable) and your credit card number, CCV number
                and expiration date.
              </li>

              <li>
                “Transaction” means a charge on your credit card for payment of:
                <br />
                (a) the EV charging fees charged by an EV Charging Facility; and
                <br />
                (b) the penalty, if any, charged by an EV Charging Facility for
                parking in an EV Charging Station without a reservation or
                without using the EV charging services or both.
              </li>
              <li>
                “User” means a person registered to use the Asgard EV App and
                Services.
              </li>
              <li>
                In these Terms and Conditions, unless stated otherwise:
                <br />
                (a) references to the words “include” and “including” are to be
                construed as illustrative and without limitation; <br />
                (b) the use of the words “must” or “should” in relation to an
                action, consideration or measure indicates that it is a
                mandatory requirement; <br />
                (c) references to clauses are to clauses of these Terms and
                Conditions; and <br />
                (d) words importing the singular include the plural and vice
                versa.
              </li>
            </ol>
          </li>

          {/* term 2 */}
          <li>
            <strong>Registration and activation</strong>
            <div className="m-4 text-sm">
              Unless otherwise defined, these terms should have the following
              meanings: meanings:
            </div>
            <ol>
              <li>
                The Service is only available to Users registered to use the
                Services. The Services are available through: <br />
                (a) the Asgard EV App (Users must also be registered to use the
                Asgard EV App); and <br />
                (b) Asgard EV payment kiosks which may be available at certain
                EV Charging Facilities. User of an Asgard EV payment kiosk
                requires your input of the Required Information and your
                agreement to be bound by these Terms and Conditions, the PICS
                and the Privacy Policy. Use of a payment kiosk does not require
                the download of the Asgard EV App or registration as a User of
                the Asgard EV App.
              </li>
              <li>
                To register as a User of the Services, you must submit the
                Required Information on the registration form for the Services
                in the Asgard EV App (or at an Asgard EV payment kiosk) and
                agree to these Terms and Conditions. By applying for
                registration of the Services, or by using an Asgard EV payment
                kiosk, you agree and confirm I can contact you using your Asgard
                EV App account (as applicable) or directly using your Required
                Information.
              </li>
              <li>
                By submitting your application for registration of the Services,
                or by using an Asgard EV payment kiosk, you warrant that:
                <br /> (a) you are the owner (or a duly authorised driver (i.e.,
                listed on the vehicle’s insurance policy)) of the registered
                license plate number as provided in your Services application or
                as entered through an Asgard EV payment kiosk;
                <br /> (b) you are the holder (or a duly authorised signatory)
                of the credit card detailed in your Services application or as
                entered through an Asgard EV payment kiosk; <br />
                (c) any information you provide to me, including your <br />
                personal information, is accurate, complete and up to date; and{" "}
                <br />
                (d) you will provide me with updates to any information you
                previously provided if that information changes.
              </li>
              <li>
                By submitting your application for registration of the Services,
                or by entering the Required Information at an Asgard EV payment
                kiosk, you agree and give me your consent to: pass your
                registered license plate number as provided in the Required
                Information to the <br /> (a) relevant EV Charging Facilities;
                <br />
                (b) receive your registered license plate number from the
                relevant EV Charging Facilities; <br />
                (c) use your credit card information, including your name,
                credit card number, CVC (card verification code) number and
                expiration date, to share the information with your credit card
                company, your credit card issuer or my payment gateway provider,
                as applicable, and to conduct Transactions. This credit card
                information will never be stored by me. Your credit card
                company, your credit card issuer or my payment gateway provider,
                as applicable, may provide me with a token to identify you and
                with which I can track your transactions for reporting and other
                purposes detailed below; <br />
                (d) to use your mobile device identification number to identify
                you and your activities related to the Transactions and
                Services; and
                <br /> (e) use your Asgard EV App User identification number (as
                applicable) to identify you and your car to provide the Services
                and conduct Transactions.
              </li>
              <li>
                Each EV Charging Facility may have separate terms and conditions
                which you should read carefully, and you should confirm that you
                agree to those additional terms and conditions before use. I do
                not accept any liability resulting from the terms and conditions
                issued by an EV Charging Facility used by you or if any such EV
                Charging Facility fails to appropriately provide its services or
                meet its obligations or responsibilities.
              </li>
              <li>
                I may suspend or terminate your Asgard EV App account or
                Services account, as applicable, if it is inactive for more than
                180 days.
              </li>
              <li>
                A registered license plate number can only be registered under 1
                User at a time, and a User can have only 1 registered license
                plate number registered with the Services at a time. You must
                de-register your registered license plate number before it can
                be registered to a different Services account or before you can
                register a different registered license plate number with your
                Services account.
              </li>
              <li>
                It is your responsibility to enable the push notification
                setting on your mobile device and to provide me with notice of
                any changes to your Asgard EV App account (in particular, any
                changes to your Asgard EV App identification number) in order to
                timely receive notices regarding the Services. I will contact
                Users using push notifications, in-app messages or both. You
                should never respond to any messages or phone calls that appear
                to be from me asking you to provide your account or security
                details. You will be considered having received any notice given
                by me immediately after the notice has been sent via push
                notification or in-app message. Push notification messages are
                sent to your mobile devices through third-party messaging
                services. Any delay or failure in delivering the notifications
                due to the third-party messaging services is beyond my control.
                In-app messages are sent through the Asgard EV App. Any delay or
                failure in delivering the notifications due to connectivity
                issues with the Asgard EV App is beyond my control. I must not
                be liable for any loss or for any other consequences suffered or
                incurred by you in relation to the delay or failure in receiving
                the notifications. I must not be liable for any loss or for any
                other consequences suffered or incurred by you in relation to
                the delay or failure in receiving the notifications sent by push
                notification or in-app message.
              </li>
              <li>
                You may apply for cancellation of the Services at any time
                through the Asgard EV App provided that there is no outstanding
                payment due.
              </li>
              <li>
                I may immediately suspend your Services account if there is any
                outstanding payment due and unpaid.
              </li>
              <li>
                I will terminate the Services immediately if I receive notice
                that your credit card has been terminated, cancelled or expired.
              </li>
              <li>
                In addition to clauses 3.6 and 3.8 below, and such other
                provisions as expressly provided in these Terms and Conditions,
                I reserve the right to cancel, terminate or suspend the
                Services, the Asgard EV App or both at any time without
                specifying the reasons. I will take reasonable steps to minimize
                any inconvenience caused to you by such cancellation,
                termination or suspension.
              </li>
            </ol>
          </li>

          {/* term 3 */}
          <li>
            <strong>Payment for Transactions</strong>

            <ol>
              <li>
                Once payment for a Transaction is processed, the amount will be
                credited to your credit card. All payments are non-refundable
                and irreversible.
              </li>
              <li>
                I am responsible for calculating the amount of any Transaction.
                For the Service, you will need to: <br />
                (a) use the Asgard EV App to use the Asgard EV services at the
                EV Charging Facility; or <br />
                (b) enter your registered license plate number at the parking
                redemption in the EV Charging Facility. Each EV Charging
                Facility, at its sole discretion, will determine its EV charging
                rules and terms and conditions. For any charge amount less than
                1 kWh, the full price of 1 kWh will be applied.
              </li>
              <li>
                I am not responsible for any errors related to or miscalculation
                of the EV charging fees due to the operators of an EV Charging
                Facility not providing me with adequate advance notice of the
                changes made to its:
                <br /> (a) schedule of EV charging fees; or
                <br /> (b) terms and conditions for EV charging services.
              </li>
              <li>
                You should contact the relevant EV Charging Facility in relation
                to: <br />
                (a) any car-parking related matters; or <br />
                (b) any goods and services offered or provided by the relevant
                EV Charging Facility (including the rules and terms and
                conditions for EV charging services).
              </li>
              <li>
                After each successful Transaction you will receive a record of
                payment sent via a push notification, text message, in-app
                message, email or some combination of them to your mobile device
                which serves as a confirmation of such payment. You must enable
                push notifications on your mobile device to ensure you receive
                the Transaction record. A record of payment may also be
                available in the “History” tab in the Asgard EV App.
                <br /> (a) If you choose the option ‘charge to full capacity’,
                your credit card will be automatically charged once the process
                is completed. Payment notification will be sent to you via SMS
                text message, in-app message, email or some combination of them.{" "}
                <br />
                (b) If you choose the option ‘partially charge’, your credit
                card will be charged after the option ‘stop charging and pay’ is
                chosen. Payment notification will be sent to you via SMS text
                message, in-app message, email or some combination of them. You
                must ensure that there is sufficient credit in your credit card
                account.
                <br /> (c) A penalty/fine may be imposed for overparking the
                vehicle at the charging station after the charging process is
                completed. Please check the Asgard EV App for details on fees.
              </li>

              <li>
                before using the Services and attempting to pay any outstanding
                amounts for the Services.
              </li>
              <li>
                Any amount owed for a Transaction will become immediately due
                and payable. At my sole discretion, your use of the Services
                will be suspended until full settlement of all outstanding
                amounts.
              </li>
              <li>
                You may receive a payment reminder from me via push
                notification, SMS text message, in-app message, email or some
                combination of them in respect of any issues regarding
                settlement of any amount owed for a Transaction.
              </li>
              <li>
                If any amount of a Transaction remains outstanding for 15 days
                or more, without prejudice to other rights and remedies
                available to me, I reserve the right to terminate the Services,
                any of my other services or any combination of them.
              </li>
              <li>
                In case of any disputes regarding the crediting of payment on
                your credit card, you may contact my customer service for
                assistance (see clause 3.13 for contact information).
              </li>
              <li>
                If I cancel or terminate your Asgard EV account for any reason,
                the registered license plate number and credit card number
                registered with your cancelled or terminated Asgard EV account
                cannot be subsequently used for application for registration of
                the Services or a new Asgard EV account.
              </li>
              <li>
                If you believe that the Services were terminated, cancelled or
                suspended wrongly or in error, you may contact my customer
                service (see clause 3.13 for contact information).
              </li>
              <li>
                The contact information for my customer service is:
                <br />
                <span>Email : hello@asgardev.com.hk</span>
                <br />
                <span>Support hotline : 8401 3062</span>
                <br />
                <span>General enquiry : 8401 3062</span>
              </li>
            </ol>
          </li>

          {/* term 4 */}
          <li>
            <strong>Your responsibilities</strong>
            <ol>
              <li>
                You are responsible for keeping all information, including the
                Required Information provided to me, up to date. You should
                apply for cancellation of the Services in the event of change of
                ownership of the registered license plate number registered for
                the Services or revocation of grant of the registered license
                plate number by the applicable authority for whatever reason, as
                the case may be. 4.2 You must indemnify me against all actions,
                proceedings, liabilities, claims, loss, damages and reasonable
                costs and expenses (including all reasonable legal fees) which
                may be taken against me or which I may suffer, sustain or incur
                howsoever arising out of or in connection with any
                inappropriate, misuse or unauthorised use of the Services or the
                Asgard EV App.
              </li>
              <li>
                You must indemnify me against all actions, proceedings,
                liabilities, claims, loss, damages and reasonable costs and
                expenses (including all reasonable legal fees) which may be
                taken against me or which I may suffer, sustain or incur
                howsoever arising out of or in connection with any
                inappropriate, misuse or unauthorised use of the Services or the
                Asgard EV App.
              </li>
            </ol>
          </li>

          {/* term 5 */}
          <li>
            <strong>Your responsibilities</strong>
            <ol>
              <li>
                Your use of the Service, if any and as applicable, must comply
                with the rules and terms and conditions for the EV charging
                services provided by the applicable EV Charging Facility. Each
                EV Charging Facility participating in the Service may have
                separate terms and conditions for its EV charging services which
                you should read carefully, and you should confirm that you agree
                to those terms and conditions before use of those EV charging
                services.
              </li>
              <li>
                Your registration for the Services is limited to 1 vehicle and
                its associated registered license plate number.
              </li>
              <li>
                Your registration for the Services is limited to 1 credit card
                and only 1 credit card may be registered with your Services
                account.
              </li>
              <li>
                I (or the operator of the EV Charging Facility) may install and
                use video cameras in or near the EV Charging Facility. Such
                video cameras will be used:
                <br /> (a) to capture the registered license plate number of the
                vehicle using the carpark facilities; and <br />
                (b) for security purposes. Your activities, and that of other
                members of the public, may be recorded, under surveillance or
                both by such video cameras. The EV Charging Facility operator or
                I will post and maintain sufficient notices in prominent
                positions near such video cameras to alert the public or the
                affected individuals that their activities may be recorded,
                under surveillance or both by such video cameras. Any use I make
                of such video cameras will comply with Personal Data (Privacy)
                Ordinance (Cap. 486, Laws of Hong Kong) and any other applicable
                laws, ordinances, regulations and rules as imposed from time to
                time by any combination of the Hong Kong Government and other
                competent authorities.
                <br />
                <div className="flex flex-col laptop:flex-row gap-6 my-10">
                  <div className="flex flex-[2] flex-col gap-5 p-8 bg-mainDark rounded-3xl text-white">
                    <div className="flex flex-col text-mainYellow">
                      <span className="text-2xl laptop:text-3xl font-bold">
                        公平收費
                      </span>
                      <span className="text-sm laptop:text-xl">
                        Fair Use Charging
                      </span>
                    </div>
                    <div className="flex flex-col gap-3 text-lightDark">
                      <span className="text-sm laptop:text-lg">
                        ASGARD EV
                        希望保障每一位使用者的權益，所以我們制定公平收費政策，以協助資源得到妥善利用。
                      </span>
                      <span className="text-xs laptop:text-base">
                        ASGARD EV aims to protect the rights of every user,
                        which is why we have established a fair pricing policy
                        to ensure the proper utilization of resources.
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-row laptop:flex-col flex-1 gap-8 laptop:gap-5 p-8 bg-mainDark rounded-3xl text-white justify-between items-center laptop:items-start">
                    <div className="flex flex-col text-mainYellow">
                      <span className="text-2xl laptop:text-3xl font-bold">
                        佔用費
                      </span>
                      <span className="text-sm laptop:text-xl">Overstay</span>
                    </div>
                    <div className="flex flex-col text-white">
                      <span className="text-4xl laptop:text-4xl font-extrabold">
                        $5
                      </span>
                      <span className="text-sm laptop:text-xl">
                        /每分鐘 min
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-row laptop:flex-col flex-1 gap-8 laptop:gap-5 p-8 bg-mainDark rounded-3xl text-white justify-between items-center laptop:items-start">
                    <div className="flex flex-col text-mainYellow">
                      <span className="text-2xl laptop:text-3xl font-bold">
                        非充電動汽車使用
                      </span>
                      <span className="text-sm laptop:text-base font-bold">
                        Non-electric vehicle use
                      </span>
                    </div>
                    <div className="flex flex-col text-white">
                      <span className="text-4xl laptop:text-4xl font-extrabold">
                        $320
                      </span>
                      <span className="text-sm laptop:text-base font-bold">
                        /解鎖費用 Unlocking fee
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </ol>
          </li>

          {/* term 6 */}
          <li>
            <strong>Disclaimer of liability</strong>
            <ol>
              <li>
                You agree and acknowledge that the operators of EV Charging
                Facilities are solely responsible for the provision of goods and
                services they offer or provide (including car parking services).
                I must have no liability to any person whatsoever in respect of
                any goods, services or any combination of them offered or
                provided by any operator of the EV Charging Facility. Each EV
                Charging Facility has its own rules and terms and conditions of
                use.
              </li>
              <li>
                I hold no responsibility for any inappropriate or unauthorised
                use of your registered license plate number, your credit card or
                any combination of them in respect of the Services and you
                remain liable for any and all payments incurred arising from or
                in connection with any such inappropriate or unauthorised use.
              </li>
              <li>
                In no event must I be liable, whether in contract (including
                intentional breaches), tort (including negligence) or otherwise,
                for any loss or damage of any kind whatsoever arising from or in
                connection with use of the Services or of the Asgard EV App or
                of any Asgard EV payment kiosk.
              </li>
            </ol>
          </li>

          {/* term 7 */}
          <li>
            <strong>Personal information collection statement (PICS)</strong>
            <ol>
              <li>
                To enable us to provide the Services to you, you agree that I
                can collect, hold, process and use your personal information and
                other information (“Required Information”). If you do not agree
                to provide the Required Information to me, I may not be able to
                provide you with the Services you request. The Required
                Information should also include other data, including mobile
                device identification number, IP (internet protocol) address and
                domain name which may be collected during your use of the
                Services. The Required Information will be handled in accordance
                with these Terms and Conditions (which includes the PICS) and
                the Privacy Policy which is posted on my website.
              </li>
              <li>
                You agree that I may collect, use, process, retain, disclose or
                transfer any of the Required Information for one or more of the
                following purposes: <br />
                (a) providing the Services to you;
                <br />
                (b) maintaining and operating the Services; <br />
                (c) processing billing and payment for Transactions; <br />
                (d) to contact you about the Services or specific Transactions;
                <br />
                (e) conducting searches at the Hong Kong Transport Department or
                other relevant governmental departments and authorities for
                serving demand and legal documentation in relation to the
                recovery of any outstanding payments for Transactions or
                otherwise; <br />
                (f ) collecting moneys due from outstanding payments for
                Transactions or otherwise; and
                <br /> (g) reporting on the Services and Transactions to the
                relevant operators of EV Charging Facilities (which may include
                audits of the Services); and
                <br /> (h) to contact you about promotions and offers related to
                the Services and EV charging services provided at EV Charging
                Facilities.
              </li>
              <li>
                I may share your Required Information for the purposes of
                providing the Services to you and maintaining and operating the
                Services. The Required Information I may share includes:
                <br /> (a) registered license plate number with the operators of
                the EV Charging Facilities; <br />
                (b) your Octopus Card number (if one is registered for your
                Services account as part of the Required Information) to conduct
                and report Transactions;
                <br /> (c) your credit card information (if one is registered
                for your Services account as part of the Required Information),
                including your name, credit card number, CVC number and
                expiration date, with your credit card company, your credit card
                issuer or my payment gateway provider (currently Nuvei
                Technologies Corp.), as applicable, and to use such information
                (which is never stored by me) to conduct and report
                Transactions; <br />
                (d) a token provided by your credit card company, your credit
                card issuer or my payment gateway provider, as applicable, to
                identify you to conduct and report Transactions; <br />
                (e) information from either your credit card company, your
                credit card issuer or my payment gateway provider, as applicable
                to conduct and report Transactions; <br />
                (f ) your mobile device identification number to conduct and
                report Transactions and operate the Services; and
              </li>
              <li>
                Your Required Information will be kept confidential by me, but
                you agree that for the purposes set out in clauses 7.2 and 7.3
                above, I may transfer or disclose, under a duty of
                confidentiality to me, such Required Information to: <br />
                (a) your credit card company, your credit card issuer or my
                payment gateway provider ( Adyen hong kong limited ); <br />
                (b) my agents or contractors who provide data processing or
                other services in connection with the operation of my business
                (such as professional advisors, call center service providers,
                debt collection agencies (in the event you owe me any money),
                courier or data entry companies); and <br />
                (c) the operators of the EV Charging Facilities. The above
                agents and contractors and the operators of the EV Charging
                Facilities are located within Hong Kong except for those
                supporting data entry and processing and payment gateway
                providers which may be located outside Hong Kong.
              </li>
              <li>
                Access: You have the right to:
                <br /> (a) check whether I hold your Required Information and to
                have access to that Required Information;
                <br /> (b) require us to correct any Required Information which
                is inaccurate; and
                <br /> (c) ascertain our policies and practices in relation to
                the Required Information and to be informed of the kind of
                Required Information held by us.
              </li>
              <li>
                I may charge you a reasonable data access fee for complying with
                any request for access to your personal data and other
                information that I may collect. You can learn my current data
                access fee and whether it will be charged for your request by
                contacting my Data Protection Officer.
              </li>
              <li>
                Any data access request should be made in writing to:
                <br /> The Data Protection Officer
                <br /> Asgard Group Limited UNIT 405 , Sunbeam Centre , No.27
                Shing Yip Street , Kwun Tong , KLN
                <br /> Email: hello@asgardev.com.hk
              </li>
            </ol>
          </li>

          <div className="flex flex-col gap-2 text-lg my-10">
            <div>Personal information collection statement (PICS)</div>
            <div className="text-sm font-medium">
              I reserve the right to amend these Terms and Conditions from time
              to time without prior notice and your use of the Services
              following any such amendments constitutes your agreement to be
              bound by these Terms and Conditions.
            </div>
          </div>

          <div className="flex flex-col gap-2 text-lg mb-5">
            <div>Governing law and jurisdiction</div>
            <div className="text-sm font-medium">
              These Terms and Conditions must be governed by the laws of the
              Hong Kong Special Administrative Region of the People’s Republic
              of China (“Hong Kong”). Each of us irrevocably agree that the
              courts in Hong Kong shall have exclusive jurisdiction to settle
              any dispute or claim (whether contractual or noncontractual)
              arising out of or in connection with these Terms and Conditions,
              its subject matter or formation.
            </div>
          </div>

          <div className="flex flex-col gap-2 text-lg mb-5">
            <div>Contracts (Rights of Third Parties) Ordinance</div>
            <div className="text-sm font-medium">
              Any legislation giving rise to or conferring on third parties
              contractual or other rights, including The Contract (Rights of
              Third Parties) Ordinance (Cap. 623, Laws of Hong Kong), must not
              apply to these Terms and Conditions and no third party will have
              any rights under them. Nothing in these Terms and Conditions must
              affect the rights of any permitted assignee or transferee of these
              Terms and Conditions.
            </div>
          </div>

          <div className="flex flex-col gap-2 text-lg mb-5">
            <div>English version prevails</div>
            <div className="text-sm font-medium">
              I have provided a Chinese language translation of these Terms and
              Conditions for reference only. If there is any inconsistency or
              conflict between the English and any Chinese version, the English
              version must prevail.
            </div>
          </div>
        </ol>
      </div>

      <Footer />
    </div>
  );
};

export default TERMS;
